module.exports = __webpack_public_path__ + "9e92cbdc92ecfe890b750b9fe1e4f250.svg";